export const EmailHeader = `
<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html xmlns="http://www.w3.org/1999/xhtml">
<head>
    <meta name="viewport" content="width=device-width" />
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
    <title>Billing e.g. invoices and receipts</title>
    <style type="text/css">
        * {
        margin: 0;
        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
        box-sizing: border-box;
        font-size: 14px;
        }

        img {
        max-width: 100%;
        }

        body {
        -webkit-font-smoothing: antialiased;
        -webkit-text-size-adjust: none;
        width: 100% !important;
        height: 100%;
        line-height: 1.6em;
        margin: 0;
        /* 1.6em * 14px = 22.4px, use px to get airier line-height also in Thunderbird, and Yahoo!, Outlook.com, AOL webmail clients */
        /*line-height: 22px;*/
        }

        /* Let's make sure all tables have defaults */
        table td {
        vertical-align: top;
        }

        /* -------------------------------------
            BODY & CONTAINER
        ------------------------------------- */
        body {
        background-color: #fff;
        }

        .body-wrap {
        background-color: #fff;
        width: 100%;
        }

        .container {
        display: block !important;
        max-width: 100% !important;
        margin: 0 auto !important;
        /* makes it centered */
        clear: both !important;
        }

        .content {
        max-width: 100%;
        margin: 0 auto;
        display: block;
        padding: 20px;
        }

        /* -------------------------------------
            HEADER, FOOTER, MAIN
        ------------------------------------- */
        .main {
        background-color: #fff;
        width: 100%;
        }

        .content-wrap {
        padding: 0px;
        }

        .content-block {
        padding: 0 0 20px;
        }

        .header {
        width: 100%;
        margin-bottom: 20px;
        }

        .footer {
        width: 100%;
        clear: both;
        color: #999;
        padding: 20px;
        }
        .footer p, .footer a, .footer td {
        color: #999;
        font-size: 12px;
        }

        /* -------------------------------------
            TYPOGRAPHY
        ------------------------------------- */
        h1, h2, h3 {
        font-family: "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;
        color: #000;
        margin: 40px 0 0;
        line-height: 1.2em;
        font-weight: 400;
        }

        h1 {
        font-size: 32px;
        font-weight: 500;
        /* 1.2em * 32px = 38.4px, use px to get airier line-height also in Thunderbird, and Yahoo!, Outlook.com, AOL webmail clients */
        /*line-height: 38px;*/
        }

        h2 {
        font-size: 24px;
        /* 1.2em * 24px = 28.8px, use px to get airier line-height also in Thunderbird, and Yahoo!, Outlook.com, AOL webmail clients */
        /*line-height: 29px;*/
        }

        h3 {
        font-size: 18px;
        /* 1.2em * 18px = 21.6px, use px to get airier line-height also in Thunderbird, and Yahoo!, Outlook.com, AOL webmail clients */
        /*line-height: 22px;*/
        }

        h4 {
        font-size: 14px;
        font-weight: 600;
        }

        p, ul, ol {
        margin-bottom: 10px;
        font-weight: normal;
        }
        p li, ul li, ol li {
        margin-left: 5px;
        list-style-position: inside;
        }

        /* -------------------------------------
            LINKS & BUTTONS
        ------------------------------------- */
        a {
        color: #348eda;
        text-decoration: underline;
        }

        .btn-primary {
        text-decoration: none;
        color: #FFF;
        background-color: #348eda;
        border: solid #348eda;
        border-width: 10px 20px;
        line-height: 2em;
        /* 2em * 14px = 28px, use px to get airier line-height also in Thunderbird, and Yahoo!, Outlook.com, AOL webmail clients */
        /*line-height: 28px;*/
        font-weight: bold;
        text-align: center;
        cursor: pointer;
        display: inline-block;
        border-radius: 5px;
        text-transform: capitalize;
        }

        /* -------------------------------------
            OTHER STYLES THAT MIGHT BE USEFUL
        ------------------------------------- */
        .last {
        margin-bottom: 0;
        }

        .first {
        margin-top: 0;
        }

        .aligncenter {
        text-align: center;
        }

        .alignright {
        text-align: right;
        }

        .alignleft {
        text-align: left;
        }

        .clear {
        clear: both;
        }

        /* -------------------------------------
            ALERTS
            Change the class depending on warning email, good email or bad email
        ------------------------------------- */
        .alert {
        font-size: 16px;
        color: #fff;
        font-weight: 500;
        padding: 20px;
        text-align: center;
        }
        .alert a {
        color: #fff;
        text-decoration: none;
        font-weight: 500;
        font-size: 16px;
        }

        /* -------------------------------------
            INVOICE
            Styles for the billing table
        ------------------------------------- */
        .invoice {

        text-align: left;
        padding: 30px;
        width: 100%;
        }
        .invoice td, .invoice th {
        padding: 7px 12px;
        }
        .invoice .invoice-items {
        width: 100%;
        }
        .invoice .invoice-items td {
        border-top: #eee 1px solid;
        }
        .invoice .invoice-items .total td {
        border-top: 2px solid #333;
        border-bottom: 2px solid #333;
        font-weight: 700;
        }

        .invoice .invoice-items.no-border td {
          border-top: none;
        }



        /* -------------------------------------
            RESPONSIVE AND MOBILE FRIENDLY STYLES
        -------------------------------------
        @media only screen and (max-width: 640px) {
            body {
                padding: 0 !important;
            }

            h1, h2, h3, h4 {
                font-weight: 800 !important;
                margin: 20px 0 5px !important;
            }

            h1 {
                font-size: 22px !important;
            }

            h2 {
                font-size: 18px !important;
            }

            h3 {
                font-size: 16px !important;
            }

            .container {
                padding: 0 !important;
                width: 100% !important;
            }

            .content {
                padding: 0 !important;
            }

            .content-wrap {
                padding: 10px !important;
            }

            .invoice {
                width: 100% !important;
            }
        }
        */
    </style>
</head>
<body itemscope itemtype="http://schema.org/EmailMessage" style="margin: 0;">
`

export const EmailContent = `<table class="body-wrap">
    <tr>
      <td class="container" width="100%">
        <table class="main" width="100%" cellpadding="0" cellspacing="0">
          <tr>
            <td class="alert alert-warning">
              <table width="100%">
                <tr>
                  <td>
                    <table width="100%" class="invoice-items" cellpadding="30" cellspacing="1">
                      <tr>
                        <th width="50%" class="alignleft">Items1</th>
                        <th width="50%" class="alignright">Price</th>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td class="content-wrap aligncenter">
              <table width="100%" cellpadding="0" cellspacing="0">
                <tr>
                  <td class="content-block aligncenter">
                    <table class="invoice">
                      <tr>
                        <td>Lee Munroe<br>Invoice #12345<br>June 01 2014</td>
                        <td class="alignright">Lee Munroe<br>Invoice #12345<br>June 01 2014</td>
                      </tr>
                    </table>
                    <table class="invoice">
                      <tr>
                        <td>
                          <table class="invoice-items" cellpadding="0" cellspacing="1">
                            <tr>
                              <th>Items1</th>
                              <th class="aligncenter">Price</th>
                              <th class="aligncenter">Quantity</th>
                              <th class="aligncenter">Total</th>
                            </tr>
                            <tr>
                              <td>Service 1</td>
                              <td class="aligncenter">£20.00</td>
                              <td class="aligncenter" style="background: #ddd;">1</td>
                              <td class="aligncenter">£40.00</td>
                            </tr>
                            <tr>
                              <td class="" width="60%">&nbsp;</td>
                              <td class="aligncenter">&nbsp;</td>
                              <td class="aligncenter" style="background: #eee;">Total</td>
                              <td class="aligncenter" style="background: #eee;"><b>£33.98</b></td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table>

                    <table class="invoice">
                      <tr>
                        <td>
                          <table class="invoice-items" cellpadding="10" cellspacing="1">
                            <tr>
                              <td style="border: none;" class="" width="60%">Test Text</td>
                              <td style="border: none;" class="aligncenter">&nbsp;</td>
                              <td style="border: none;" class="" style="background: #eee;">Sub Total</td>
                              <td style="border: none;" class="aligncenter" style="background: #eee;"><b>£33.98</b></td>
                            </tr>
                            <tr>
                              <td class="" width="60%">VAT</td>
                              <td class="aligncenter">&nbsp;</td>
                              <td class="" style="background: #eee;">VAT</td>
                              <td class="aligncenter" style="background: #eee;"><b>10%</b></td>
                            </tr>
                            <tr>
                              <td class="" width="60%">Discount</td>
                              <td class="aligncenter">&nbsp;</td>
                              <td class="" style="background: #eee;">Discount</td>
                              <td class="aligncenter" style="background: #eee;"><b>10%</b></td>
                            </tr>
                            <tr>
                              <td class="" width="60%">TOTAL</td>
                              <td class="aligncenter">&nbsp;</td>
                              <td class="" style="background: #eee;">TOTAL</td>
                              <td class="aligncenter" style="background: #eee;"><b>£1000</b></td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table>



                    <table class="invoice">
                      <tr>
                        <td>
                          <table class="invoice-items" cellpadding="20" cellspacing="1">
                                            <tr>
                  <td class="content-block aligncenter">
                    <h4 style="margin:0; mso-line-height-rule:exactly;">Terms & Conditions</h4>
                    <p style="margin:0;">From the version 1.13 (May 2017) you can finally change the default modifier key for creating multiple cursors (add to settings):</p>
                  </td>
                </tr>

                            <tr style="display: none;">
                  <td class="content-block aligncenter">
                                        <a href="http://www.mailgun.com" class="btn-primary">Upgrade my account</a>
                  </td>
                            </tr>

                          </table>
                        </td>
                      </tr>
                    </table>


                  </td>
                </tr>


              </table>
            </td>
            <td></td>
          </tr>
        </table>

      </td>
    </tr>
  </table>`

export const EmailFooter = '<br/><br/><br/></body></html>'



// WEBPACK FOOTER //
// ./src/views/components/InvoiceSheet/email.js